import React from 'react'

import { callifyHtml } from '@utils/helpers'
import parse from 'html-react-parser'
import PropTypes from 'prop-types'
import Linkify from 'linkify-react'

import { useSelector } from 'react-redux'
import { selectIsElectron } from '@selectors'

import useStyles from './parsed-text.style'

import Icon from '@components/icon/icon.component'
import i18n from 'i18n-js'
import { MESSAGE_LOCATION } from '../../assets/i18n/strings'


const ParsedText = ({ className, location, text }) => {
  const Analytics = useSelector(state => state.analytic.analytics)
  const isElectron = useSelector(selectIsElectron)
  const classes = useStyles()

  const linkProps = {
    onClick: (event) => {
      if (isElectron) {
        event.preventDefault()

        window.open(event.target.innerHTML, '_blank')

        window.focus()
      }

      Analytics.logEvent('MessageLinkTap')
    }
  }

  const onClickLocation = () => {
    const url = `https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}`

    const win = window.open(url, '_blank')

    win.focus()
  }

  const sanitizedValue = text.replace(/<([^>]+@[^>]+)>/g, '$1')
  
  return (
    <Linkify
      as='span'
      className={className}
      options={{ attributes: linkProps }}
    >{parse(callifyHtml(sanitizedValue))}
      {location &&
        <div className={classes.reportFooter}>
          <button
            className={classes.button}
            onClick={onClickLocation}
          >
            <span className={classes.buttonText}>{i18n.t(MESSAGE_LOCATION)}</span>
            <Icon type='pin-small' />
          </button>
        </div>}
    </Linkify>
  )
}

ParsedText.defaultProps = {
  className: '',
  location: null,
  text: ''
}

ParsedText.propTypes = {
  className: PropTypes.string,
  location: PropTypes.object,
  text: PropTypes.string
}

export default ParsedText
